import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsDoneWorksCosts(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,dtConfig[ModulesMap.REPORTS_DONE_WORKS_COSTS].getReportsDoneWorksCosts,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}
function getReportsDoneWorksCost(companyId, doneWorksCostsId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,dtConfig[ModulesMap.REPORTS_DONE_WORKS_COSTS].getReportsDoneWorksCost,
		{
			urlParams: {
				companyId: companyId,

				doneWorksCostsId,
			},
			params: query,
		}
	)
}
function getReportsDoneWorksCostPreview(companyId, doneWorksCostsId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,dtConfig[ModulesMap.REPORTS_DONE_WORKS_COSTS].getReportsDoneWorksCostPreview,
		{
			urlParams: {
				companyId: companyId,

				doneWorksCostsId,
			},
			params: query,
		}
	)
}

export default {
	getReportsDoneWorksCosts,
	getReportsDoneWorksCost,
	getReportsDoneWorksCostPreview,
}
